import {Component} from 'react';



class IntermediateLogin extends Component {

    constructor(props){
        super(props);

        this.state.params=this.props.params;

        let body = {
            jwtToken: this.props.params.jwtToken
        };
        this.state.showLoader=true;
        fetch(this.props.api + '/login', {
            body: JSON.stringify(body),
            method: "POST",
            mode: 'cors',
            headers: {'content-type': 'application/json'}
        }).then(response => {
            return response.json();
        }).then(json => {
            if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                this.props.onLogoutClick(json.message);
            }else {
                if (json && json.isError === true) {
                    this.setState({errorMsg: "couldn't login please check with the support team."});
                } else {
                    this.props.onSetAuthentication(json);
                }
            }
        });
        this.state.showLoader=false;

    }

    render(){
        return null
    }

    state = {
        showLoader: true,
        params:null
    };

    }

export default IntermediateLogin;



// WEBPACK FOOTER //
// ./src/components/security/IntermediateLogin.js